import React, {Fragment} from "react";
import {Form, Formik} from "formik"
import ModalMsg from "../../../components/ModalMsg";
import ModalConfirm from "../../../components/ModalConfirm";
import NsField from "../../../components/fields/NsField";

export default function FormModificaTipoImpExpView({
                                                       id,
                                                       show,
                                                       showConfirm,
                                                       modalMsg,
                                                       closeModal,
                                                       formikRef,
                                                       translate,
                                                       SignupSchema,
                                                       optionsClassi,
                                                       principale,
                                                       addFiglio,
                                                       optionsPadri,
                                                       tipoImpExp,
                                                       handleCloseModalModifica,
                                                       handleOkModalModifica,
                                                       initValuesForm,
                                                       onSubmitForm,
                                                       onChangeTipoImpExpDati,
                                                       onChangeOrganizzazioneMadre,
                                                       validateOrganizzazioneMadre,
                                                   }) {

    return (
        <Fragment>
            <ModalMsg
                show={show}
                handleClose={closeModal}
                testo={modalMsg}/>
            <ModalConfirm
                show={showConfirm}
                handleClose={handleCloseModalModifica}
                handleOk={handleOkModalModifica}
                testo={translate("Sicuro di voler modificare la struttura madre? Questa modifica porterà ad una variazione della gerarchia delle strutture")}/>
            <Formik
                initialValues={initValuesForm}
                innerRef={formikRef}
                validationSchema={SignupSchema}
                onSubmit={onSubmitForm}
            >
                {({errors, touched, values, submitCount}) => (
                    <Form className="row g-3">
                        <div className="col-md-12">
                            <NsField
                                name={"id_classe_tipo_imp_exp"}
                                label={"Classe Organizzazione*:"}
                                as={"select"}
                                options={(optionsClassi ? optionsClassi.map(o => {
                                    return {
                                        label: o.descrizione,
                                        value: o.id_classe_tipo_imp_exp,
                                    };
                                }) : [])}
                                onChange={onChangeTipoImpExpDati}
                                isDisabled={id && id !== '' && !addFiglio}
                                placeholder={translate("Seleziona una classe")}
                                formikRef={formikRef}
                                values={values}
                                errors={errors}
                                touched={touched}
                                submitCount={submitCount}
                            />
                        </div>
                        {
                            principale !== true &&
                            <div className="col-md-12">
                                <NsField
                                    name={"id_tipo_imp_exp_dati_padre"}
                                    label={"Organizzazione Madre*:"}
                                    as={"select"}
                                    options={(optionsPadri ? optionsPadri.map(o => {
                                        return {
                                            label: o.codice + ' - ' + o.descrizione,
                                            value: o.id_tipo_imp_exp_dati,
                                        };
                                    }) : [])}
                                    onChange={onChangeOrganizzazioneMadre}
                                    validate={validateOrganizzazioneMadre}
                                    isDisabled={!values['id_classe_tipo_imp_exp']}
                                    placeholder={translate("Selezionare l'organizzazione madre")}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                        }
                        <div className="col-md-6">
                            <NsField
                                name={"codice"}
                                label={"Codice:"}
                                isDisabled={tipoImpExp && tipoImpExp.id_tipo_imp_exp_dati}
                                formikRef={formikRef}
                                values={values}
                                errors={errors}
                                touched={touched}
                                submitCount={submitCount}
                            />
                        </div>
                        <div className="col-md-6">
                            <NsField
                                name={"descrizione"}
                                label={"Descrizione*:"}
                                formikRef={formikRef}
                                values={values}
                                errors={errors}
                                touched={touched}
                                submitCount={submitCount}
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </Fragment>
    );
}